import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=7fbf7022&scoped=true"
import script from "./Distributor.vue?vue&type=script&lang=js"
export * from "./Distributor.vue?vue&type=script&lang=js"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=7fbf7022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf7022",
  null
  
)

export default component.exports